import React, { FunctionComponent } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers/intlHooks";

export interface ContinueProps extends RouteComponentProps {
  to: string;
  onClick?: () => void;
  useLink?: boolean;
  disabled?: boolean;
}

const Continue: FunctionComponent<ContinueProps> = ({
  to,
  onClick,
  useLink,
  disabled,
  children,
  history,
}) => {
  const t = useTranslate();

  const handleClick = (): void => {
    history.push(to);
  };

  return (
    <section className="ContinueSection">
      {useLink ? (
        <a
          className="ds-c-button ds-c-button--big ds-c-button--primary"
          data-testid="continue"
          href={to}
        >
          {children ? children : t("landing_page.continue")}
        </a>
      ) : (
        <Button
          disabled={disabled}
          variation="primary"
          className="e2e-continue-button"
          size="big"
          onClick={onClick || handleClick}
          data-testid="continue"
        >
          {children ? children : t("landing_page.continue")}
        </Button>
      )}
    </section>
  );
};

export default withRouter(Continue);
